import { Link, LinkProps } from '@mui/material';
import { Link as NextLink } from 'components/common/Link';
import { useOrganisationPersonalWebshop } from 'hooks/useOrganisationPersonalWebshop';
import { Logotype, LogotypeProps } from './Logotype';

type LinkedLogotypeProps = LogotypeProps & { linkProps?: Omit<LinkProps, 'component'> };

export function LinkedLogotype(props: LinkedLogotypeProps) {
    const { linkProps, ...imageProps } = props;

    const { baseUrl } = useOrganisationPersonalWebshop();

    return (
        <Link href={baseUrl || '/'} component={NextLink} {...linkProps}>
            <Logotype {...imageProps} />
        </Link>
    );
}
